module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0115.jpg?v=d6c132b3";